import { useMemo } from "react";

// Builds the per-DB "bundle" list for the prototype's DBCard.
//
// Derivation now sources DB membership from `crate.tp_list[*].cp_db_id`
// rather than the cached `crate.active_dbs[]` array — that field lags
// behind in fixture mode (and in the live API the snapshot can be stale)
// after assign / unassign writes. Walking tp_list always reflects the
// freshest state.
//
// Each bundle exposes:
//
//   {
//     crate_id, label, crate_size, tp_count,    // # of customers from THIS
//                                                  DB on this crate
//     customers: [user_name, ...],
//     route_id, route_name,
//   }

const useDbBundles = (data) =>
  useMemo(() => {
    const cpDbs = Array.isArray(data?.cp_dbs) ? data.cp_dbs : [];
    const crates = Array.isArray(data?.data?.CRATE) ? data.data.CRATE : [];

    const byDb = new Map();
    cpDbs.forEach((db) => {
      byDb.set(String(db.cp_db_id), []);
    });

    crates.forEach((crate) => {
      const tps = Array.isArray(crate?.tp_list) ? crate.tp_list : [];
      // Aggregate this crate's customers per cp_db_id from tp_list directly.
      const cxByDb = new Map();
      tps.forEach((tp) => {
        const dbId = String(tp?.cp_db_id || "");
        if (!dbId || dbId === "MISROUTE" || dbId === "UNASSIGN") return;
        if (tp?.status && tp.status !== "ASSIGNED") return;
        const entry = cxByDb.get(dbId) || [];
        entry.push(tp);
        cxByDb.set(dbId, entry);
      });
      cxByDb.forEach((tpListForDb, dbId) => {
        if (!byDb.has(dbId)) byDb.set(dbId, []);
        byDb.get(dbId).push({
          crate_id: crate.crate_id || crate.title,
          label: crate.title || crate.crate_id,
          crate_size: crate.crate_size || null,
          tp_count: tpListForDb.length,
          customers: tpListForDb.map((tp) => tp?.user_name).filter(Boolean),
          route_id: crate.route_id || tpListForDb[0]?.route_id || null,
          route_name: crate.route_name || tpListForDb[0]?.route_name || null,
        });
      });
    });

    return byDb;
  }, [data]);

export default useDbBundles;
